export default [
  {
    id: 1,
    quote: 'If you want quality and longevity, buy a Cummins. Very satisfied.',
    author: 'John M.',
  },
  {
    id: 2,
    quote: `I cannot express my deep appreciation to you folks 
    at Cummins for the design/engineering/\
    manufacturing of this excellent product.`,
    author: 'David S.',
  },
  {
    id: 3,
    quote: `Excellent generator, excellent instillation. Would
    high recommend this unit to anyone looking for a
    top-notch generator. Cummins is the only way to go!`,
    author: 'Bradley C.',
  },
  {
    id: 4,
    quote: 'I’ve never been happier with my purchase. No worries, no fuss, no problems. Thanks, Cummins.',
  },
];



// WEBPACK FOOTER //
// ./src/views/Home/components/GeneratorReviews/data/reviews.js